<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.item.id) ? 'red lighten-1' : propRequired(header.value,props.item.id)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false
      },
      {
        text: "Name",
        value: "name",
        sortable: false
      },
      {
        text: "Earn Code",
        value: "earnCode",
        sortable: false
      },
      {
        text: "MAmount",
        value: "mAmount",
        sortable: false
      },
      {
        text: "DAmount",
        value: "dAmount",
        sortable: false
      },
      {
        text: "HAmount",
        value: "hAmount",
        sortable: false
      },
      {
        text: "Effect Date",
        value: "effectDate",
        sortable: false
      },
      {
        text: "Start Date",
        value: "startDate",
        sortable: false
      },
      {
        text: "End Date",
        value: "endDate",
        sortable: false
      },
      {
        text: "IsIndefinite",
        value: "isIndefinite",
        sortable: false
      },
      {
        text: "LateFlag",
        value: "lateFlag",
        sortable: false
      },
      {
        text: "UTFlag",
        value: "utFlag",
        sortable: false
      },
      {
        text: "AbsFlag",
        value: "absFlag",
        sortable: false
      },
      {
        text: "LeaveFlag",
        value: "leaveFlag",
        sortable: false
      },
      {
        text: "Active",
        value: "active",
        sortable: false
      },
      {
        text: "IsFixed",
        value: "isFixed",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index &&
          item.mode == "ALLO"
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return (
          item.property == "ALL" && item.mode == "ALLO" && item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>